import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const EL = '.js-gallery';

if (document.querySelector(EL)) {
  const slider = new Splide(EL, {
    type: 'loop',
    arrows: false,
    pagination: false,
    gap: 20,
    drag: 'free',
    autoScroll: {
      speed: 1,
    },
    breakpoints: {
      1024: {

      },
      767: {

      },
    },
  });

  slider.mount({ AutoScroll });

  const track = slider.Components.Elements.track;

  track.addEventListener('mouseover', () => slider.Components.AutoScroll.pause());
  track.addEventListener('mouseleave', () => slider.Components.AutoScroll.play());
}
